import { z } from "zod"

export const loginSchema = z.object({
  username: z.string().trim().min(1, "Ange ditt användarnamn"),
  password: z.string().min(1, "Ange ditt lösenord"),
})

export type LoginInput = z.input<typeof loginSchema>
export type LoginValues = z.output<typeof loginSchema>

// Must mirror the backend validation rules.
const usernameRegex = /^[a-zA-Z0-9_.-]+$/

export const registerSchema = z
  .object({
    username: z
      .string()
      .trim()
      .min(3, "Minst 3 tecken")
      .max(32, "Högst 32 tecken")
      .regex(usernameRegex, "Endast bokstäver, siffror och _ . -"),
    password: z.string().min(8, "Minst 8 tecken"),
    confirmPassword: z.string().min(1, "Bekräfta ditt lösenord"),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.confirmPassword) {
      ctx.addIssue({
        code: "custom",
        message: "Lösenorden matchar inte",
        path: ["confirmPassword"],
      })
    }
  })

export type RegisterInput = z.input<typeof registerSchema>
export type RegisterValues = z.output<typeof registerSchema>
